<template>
 <!-- <PrimevuePanel class="  border-solid border-1 surface-border">   
 
    
     <div v-if="!this.$props.communication" class="mb-2 font-medium text-xl">{{this.$props.message.subject}}</div> 

   
    <form @submit.prevent="sendMessage" name="messageForm">
        <div class="flex flex-wrap">
            <div class="w-2 align-items-center ">
                <PrimevueButton type="submit" label="Odoslať" iconPos="top" v-tooltip.top="{ value: 'Zaslanie správy' }" icon="pi pi-send" text size="large">
                    
                </PrimevueButton>
                
            </div>
            <div class="w-10">
                <PrimevueTextarea v-model="text" class="w-full"  />
            </div>

        </div>
    </form>
     <div class="mt-1 mb-1 border-solid border-1 surface-border"></div> -->
    <FileUpload name="files[]" url="" :multiple="true" :maxFileSize="10000000" 
                class="  border-solid border-1 surface-border"
                :customUpload="true" @select="onSelectedFiles">
           
        <template #header="{ chooseCallback,clearCallback }">
            <div class="flex flex-wrap justify-content-between align-items-center flex-1 gap-2">
                <div class="flex align-items-center">
                    <span class="text-2xl font-bold" >Nahrávanie príloh</span>
                </div>                
                <div class="flex gap-2"> 
                    <PrimevueButton class="" label="Vybrať súbory" 
                      :disabled="false"
                      severity="success" icon="pi pi-plus" raised @click="chooseCallback()"/>
                    <PrimevueButton class="" label="Nahrať súbory" 
                      :disabled="false"
                      severity="success" icon="pi pi-upload" raised @click="uploadFiles()"/>                      
                </div>    
            </div>
            <!-- <div class="flex flex-wrap justify-content-between align-items-center flex-1 gap-2"> 
                <div class="flex gap-2"> 
            <PrimevueButton @click="chooseCallback()" v-tooltip.top="{ value: 'Priloženie prílohy k správe' }" icon="pi pi-paperclip" text size="large">
            </PrimevueButton>
            -->

            <div ref="uploadDiv" @afterUploadFiles="clearCallback()">  </div>  
        </template>
        
        <template #content="{ files, removeFileCallback }">
            
            <div v-if="files.length > 0">
               
                <div class=" pt-1 pb-1 flex flex-wrap gap-1">
                    <div v-for="(file, index) of files" :key="file.name + file.type + file.size" class="shadow-2 p-1 flex surface-card w-10rem">
                        <div class="w-10">
                            <!--
                            <div class="text-700 text-base font-medium mb-1">
                                 {{ this.attTypes[index].name }} 
                            </div>
                             -->
                            <div class="text-500 text-sm font-medium overflow-hidden text-overflow-ellipsis">{{file.name}}</div>
 
                            <div class="text-400 text-xs">{{ formattedFileSize(file.size) }}</div>

                        </div>
                        <div class="w-2 align-items-center flex">
                            <PrimevueButton class="file-danger" icon="pi pi-times" @click="onRemoveTemplatingFile(file, removeFileCallback, index)" severity="danger" />
                        </div> 
                    </div>
                       
                    
                </div>

            </div>


        </template>
        
        <template #empty>
            <div class="flex align-items-center justify-content-center flex-column">
                <i class="pi pi-cloud-upload border-2 border-circle p-2 text-sm text-400 border-400" />
                <p class="text-400 mt-2 mb-0">Potiahnutím sem pridáte súbory</p>
            </div>
        </template>
       

    </FileUpload>


<!--</PrimevuePanel> -->

</template>

<script lang="ts">
import Security from './security'
import {store} from './store'
import notie from "notie/dist/notie";
import Utils from '@/components/utils';
import FileUpload from 'primevue/fileupload';
//import PrimevuePanel from 'primevue/panel';
//import PrimevueSelect from "primevue/dropdown";
import PrimevueButton from "primevue/button";
//import PrimevueTextarea from 'primevue/textarea';
//import {emiter} from '../main';
//import router from "@/router";

export default {
    name: 'EditorMessageInt',
    components: {
        FileUpload,
        //PrimevuePanel,
        //PrimevueTextarea,
        PrimevueButton,
        //PrimevueSelect,
    },
    props: {
        orderId: String,
    },
    data() {
        return {
            store,
            files: [],
            //text: "",
            //selectedAttType: null,
            //attTypes: [],
        }
    },
    computed: {
      Utils() {
        return Utils
      },
    },
    methods: {
        deleteData(){
            this.$nextTick(() => {
                const uploadDiv = this.$refs.uploadDiv;
                uploadDiv.dispatchEvent(new CustomEvent('afterUploadFiles'));
            });

            this.files = []
            //console.log("Delete:", this.files)
            //this.text = ""
            //this.attTypes = []
        },

        formattedFileSize(fileSize : number): string {
            //const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            //if (fileSize == 0) return '0 KB';
            //const i = Math.floor(Math.log(this.fileSize) / Math.log(1024));
            return Math.round(fileSize / Math.pow(1024, 1)) + ' KB'; //sizes[i];
        },

        onRemoveTemplatingFile(file, removeFileCallback, index) {
            //console.log("Delete file:", file)
            //console.log("Delete index:", index)
            removeFileCallback(index)
            //this.files.splice(index,1)
            //console.log("Files:", this.files);
            //this.attTypes.splice(index,1);
        },

        onSelectedFiles(event) {
            //this.attTypes.push(this.selectedAttType);
            //this.selectedAttType = null
            this.files = event.files;
            //console.log("Files:", this.files);

        },
        
        async uploadFiles(){

            const formData = new FormData();
            
            //formData.append('bodyText', this.text);
            formData.append('orderId', this.orderId);
            
            //this.attTypes.forEach((type) => {
            //    formData.append('attTypes', String(type.id));
            //});
            this.files.forEach((file) => {
                formData.append('files', file);
            });
            //console.log("Form data:", formData.values())
            fetch(store.Api_url + "/upload-files" , Security.requestMultipartOptions("POST",formData))
              .then((response) => response.json())
              .then((responseData) => {
                if (responseData.error) {
                  //console.log("error:", responseData.message);
                    notie.alert({
                        type: 'error',
                        text: responseData.data.message,
                        position: "bottom"
                    })  
                    //this.deleteData();        
                } else {
                  
                    notie.alert({
                        type: 'success',
                        text: "Súbory boli úspešne nahraté"
                    })

                    Utils.getAttachments(this.orderId)
                    this.deleteData();

                    //emiter.emit('reloadAttByType');
                    
                }
            });
        },



    },
    beforeMount() {

      Security.requireToken();
      //store.selectModul = this.$route.path.split("/")[1]
      //this.store.order = {...this.store.order_default};

  },
}    
</script>

<style>
.p-fileupload .p-fileupload-content {
    padding: 1rem 1rem;
}
</style>
